// extracted by mini-css-extract-plugin
export default {"contentBanner":"ContentBanner-module__contentBanner--wcggg","link":"ContentBanner-module__link--cQ42U"};